import React from 'react';
import { useTheme } from 'styled-components';
import { GapSizeType } from '../../../theme/type/gap-type';
import { AllocationsProgressBarVariantType } from '../../../theme/type/allocations-progress-bar-type';
import { cn, marginBottomClass } from '../../../utils/tailwind';

type AllocationsProgressBarProps = {
    value: number;
    variant?: AllocationsProgressBarVariantType;
    background?: AllocationsProgressBarVariantType;
    children?: React.ReactChild;
    showFullBar?: boolean;
    twoLabels?: boolean;
    gap?: GapSizeType;
};

export const AllocationsProgressBar: React.FC<AllocationsProgressBarProps> = ({
    value = 0,
    children,
    variant = 'primary',
    showFullBar = false,
    gap = 'none',
}: AllocationsProgressBarProps) => {
    const theme = useTheme();

    return (
        <div className={cn('relative flex w-full items-center', marginBottomClass[gap])}>
            <div
                className="relative flex w-full items-center rounded-[var(--alloc-progress-radius)]"
                style={
                    {
                        '--alloc-progress-radius': theme.allocationsProgressBar.base.radius,
                        padding: children ? theme.allocationsProgressBar.base.padding : '0.3rem',
                    } as React.CSSProperties
                }
            >
                <div
                    className="absolute left-0 h-full max-w-full rounded-large"
                    style={{ width: `${value}%`, backgroundColor: theme.allocationsProgressBar.variant[variant].bar }}
                />
                <div className={cn('z-[1] w-auto', showFullBar && 'w-full')}>{children && children}</div>
            </div>
        </div>
    );
};
